import { render, staticRenderFns } from "./cabinet-fl44-external-purchase-card-copy-button.vue?vue&type=template&id=82f50aec&"
import script from "./cabinet-fl44-external-purchase-card-copy-button.vue?vue&type=script&lang=js&"
export * from "./cabinet-fl44-external-purchase-card-copy-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82f50aec')) {
      api.createRecord('82f50aec', component.options)
    } else {
      api.reload('82f50aec', component.options)
    }
    module.hot.accept("./cabinet-fl44-external-purchase-card-copy-button.vue?vue&type=template&id=82f50aec&", function () {
      api.rerender('82f50aec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cabinet/fl44/cards/partials/cabinet-fl44-external-purchase-card-copy-button.vue"
export default component.exports